import { type AssetTypeStatus } from "@overmap-ai/common"
import { selectAssetTypeStatusById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { assetStatusTypeMapping } from "../../mappings/assets"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuIconWithWrapper, type LuIconWithWrapperProps } from "./LuIconWithWrapper"
import type { IconsProps } from "./typings"

interface AssetTypeStatusIconProps extends Omit<LuIconWithWrapperProps, "color" | "icon"> {
	assetTypeStatusId: AssetTypeStatus["uuid"]
}

export const AssetTypeStatusIcon = memo<AssetTypeStatusIconProps>((props) => {
	const { ref, assetTypeStatusId, ...rest } = props

	const assetTypeStatus = useAppSelector(selectAssetTypeStatusById(assetTypeStatusId))!

	const { icon } = assetStatusTypeMapping[assetTypeStatus.type]

	return <LuIconWithWrapper ref={ref} color={assetTypeStatus.color} icon={icon} {...rest} />
})
AssetTypeStatusIcon.displayName = "AssetTypeStatusIcon"

interface AssetTypeStatusIconsProps extends IconsProps {
	assetTypeStatusIds: AssetTypeStatus["uuid"][]
}

export const AssetTypeStatusIcons = memo<AssetTypeStatusIconsProps>((props) => {
	const { ref, className, assetTypeStatusIds, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{assetTypeStatusIds.slice(0, max ?? assetTypeStatusIds.length).map((assetTypeStatusId) => (
				<AssetTypeStatusIcon assetTypeStatusId={assetTypeStatusId} key={assetTypeStatusId} background />
			))}
		</span>
	)
})
AssetTypeStatusIcons.displayName = "AssetTypeStatusIcons"
